import { WidgetsServicesReportFormMain } from '@/widgets/services-report-form';

export const PagesServicesPhotoFormMain = () => <WidgetsServicesReportFormMain reportType="PHOTO" />;
